/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Vishal Kumar",
  title: "Hi all, I'm Vishal and people call me ViKu too",
  subTitle: emoji(
    "A passionate Robotics Software Developer 🚀 having an experience of building software for Manipulators and Mobile Robots with Robot Operating System(ROS) / C++ / Python and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/drive/folders/1EbBe3qXV0C_4ABoMcaCczDfzlvbbfCaT?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Vi-Ku",
  linkedin: "https://www.linkedin.com/in/vi-ku",
  gmail: "vishalmimani008@gmail.com",
  // gitlab: "http",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY ROBOTICIST WHO WANTS TO EXPLORE EVERY ROBOTICS TECH ",
  skills: [
    emoji(
      "⚡ Develop Control System for Robots"
    ),
    emoji("⚡ Interactive GUI for controlling robots"),
    emoji(
      "⚡ Integration of different Sensors to provide robots with the ability to perceive and interpret their environment effectively  "
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "ROS",
      fontAwesomeClassname: "fab fa-robot"
    },
    {
      skillName: "C/C++",
      fontAwesomeClassname: "fab fa-cuttlefish"
    },
    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    {
      skillName: "Matlab",
      fontAwesomeClassname: "fab fa-matlab"
    },
    // {
    //   skillName: "aws",
    //   fontAwesomeClassname: "fab fa-aws"
    // },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fas fa-linux"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Indian Institute of Information Technology, Design, and Manufacturing, Kancheepuram",
      logo: require("./assets/images/iiitdmLogo.png"),
      subHeader: "Master of Technology with Specialisation in Product Design",
      duration: "July 2018 - July 2023",
      desc: "Coursework:",
      descBullets: [
        "Sensors and Instrumentation, System Thinking for Desing, Design of Intelligent System, Computer Vision, Digital Image Processing, Ergonomic Desing, Data Science, Robotics & Automation",
      ]
    },
    
    {
      schoolName: "Indian Institute of Information Technology, Design, and Manufacturing, Kancheepuram",
      logo: require("./assets/images/iiitdmLogo.png"),
      subHeader: "Bachelor of Technology in Mechanical Engineering with Specialisation in Design and Manufacturing",
      duration: "December 2018 - July 2023",
      desc: "Coursework:",
      descBullets: [
        "Microprocessor and Microcontroller, Electrical Drives, Probablistic Design, Design of Hybrid and Electric Vehicle",
      ]
    },
    {
      schoolName: "Guru Harkrishan Public Senior Secondary School, Hanumangarh",
      logo: require("./assets/images/shivjyotiLogo.jpeg"),
      subHeader: "Higher Secondary in Science",
      duration: "May 2015 - April 2017",
      desc: "Percentage- 82"
    },
    {
      schoolName: "Shah Satnam Ji Boys School, Sirsa",
      logo: require("./assets/images/misLogo.jpeg"),
      subHeader: "10th",
      duration: "May 2013 - March 2015",
      desc: "CGPA 9.0"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "ROS", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Python",
      progressPercentage: "70%"
    },
    {
      Stack: "C++",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Technical and Managerial Advisor",
      company: "Mars Research Station",
      companylogo: require("./assets/images/marsLogo.png"),
      date: "October 2022 – Present",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Mentoring the team for multiple aspects of designing the systems.", 
        "Setting up a smooth workflow for building interdisciplinary systems.", 
        "Focusing on commercialising existing system developed by the team.",
        "Accessing the latest design of the rover and arm for the upcoming international competition.",
      ]
    },
    
        {
      role: "Industrial Automation Consultant",
      company: "MaDeIT Innovation Foundation",
      companylogo: require("./assets/images/madeitlogo.png"),
      date: "October 2022 – Present",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Woking on conducting studies on improving various palletizing system used for industrial automation.",
        "Thoroughly studied and analysed various platform for automation, such as WePall, ABB, UR etc.",
        "Conducted study on palletizing system  offered by different vendors for different use case and with scope of improvement.",
      ]
    },
    
        {
      role: "Robotics Software Design Engineer",
      company: "Addverb Technology Pvt. Ltd.",
      companylogo: require("./assets/images/addverbLogo.png"),
      date: "May 2022 – October 2022",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Worked on the latest Fleet Management System for the AGV in R&D.", 
        "Designed and integrated new algorithm for Deadlock Resolution in the Fleet and many other systems too.",
        "Worked on improving the simulator for the Fleet Management System.",
      ]
    },

    {
      role: "Robotics System Designer",
      company: "Mars Research Station",
      companylogo: require("./assets/images/marsLogo.png"),
      date: "January 2022 – October 2022",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Worked across multiple teams to design the autonomous vehicle equipped with robotic arm.",
"Worked with the Software team for the design and implementation of the software stack for the autonomous operation of the mars rover and robotic arm.",
"Worked with electronics team for the design, fabrication and testing of the electronics system. Designed custom library for the position and speed control of the actuators and with the team integrated it to the Nav_Stack for the control.",
"Conceptualised and Designed the control and power electronics PCB for the rover and the arm for reliability and modularity.",
"Worked closely with the mechanical team from the initial problem definition to final detail design phase for designing the mechanical system of the rover and the arm with the constraints imposed from the other systems.",
"Also worked with the sponsorship team for the commercialisation of the wheeled robot and robotic arm for generating funds for future plans.",
        "Used packages like MoveIt, SLAM, AMCL, MoveBase, EKF(Extended Kalman filter), OpenCV and many more.",
      ]
    },
    
        {
      role: "Team Lead",
      company: "Mars Research Station",
      companylogo: require("./assets/images/marsLogo.png"),
      date: "April 2020 – April 2022",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
"Started the mars research station for building a mars rover with a team of 20 people from different streams.",
"Managed multiple sub teams responsible for the design of the rover and arm, and accessing  the system(rover and arm) for possible issues in the integration aspect.",
"Handled both  the technical and managerial part for the developement of the rover.",
"With the team secured a good funding for the initial prototype from multiple corporate sponsors.",
"Participated in International competition like ERC, URC, IRC and secured a good global rank in these competitions.",
"Worked closely with multi disciplinary team for the deign and development of the mars rover with a robotic arm and primarily focusing on the system integration aspect of rover and the arm.",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects and Works",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/ercLogo.png"),
      projectName: "European Rover Challenge 2022 - Remote Formula, Team SHUNYA",
      projectDesc: "Developed Navigation Stack for Leo Rover using ROS. Worked on Sensor Fusion",
      footerLink: [
        {
          name: "Website",
          url: "https://roverchallenge.eu/en/teams/shunya/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/arm.jpeg"),
      projectName: "5 DoF Robotic Arm",
      projectDesc: "A 5 DoF manipulator capable of doing pick and place tasks using self-made GUI using PyQt. Built the Control system to control 5 different actuators to perform the task",
      footerLink: [
        {
          name: "Github",
          url: "https://github.com/Vishnu-Kr/Pick-Place-Robotic-Arm"
        }
      ]
    },
    {
      image: require("./assets/images/bot.png"),
      projectName: "MaRSBot 4",
      projectDesc: "Two wheeled differential drive bot capable of doing semi-autonomous. ",
      footerLink: [
        {
          name: "Youtube",
          url: "https://www.youtube.com/watch?v=OnQALmwZGh4"
        }
      ]
    },
    {
      image: require("./assets/images/leo.jpeg"),
      projectName: "Localization and Mapping",
      projectDesc: "Robot_localization package used for localization along with RTABMapping using ZED 2i",
      footerLink: [
        {
          // name: "Youtube",
          // url: "https://www.youtube.com/watch?v=4AaZlb4nLxw"
        }
      ]
    },
    {
      image: require("./assets/images/leo.jpeg"),
      projectName: "Odometry Fusion",
      // projectDesc: "Robot_localization package used for localization along with RTABMapping using ZED 2i",
      footerLink: [
        {
          // name: "Youtube",
          // url: "https://www.youtube.com/watch?v=4AaZlb4nLxw"
        }
      ]
    },
    {
      image: require("./assets/images/electronics.jpeg"),
      projectName: "Auto Expandable Container",
      // projectDesc: "Robot_localization package used for localization along with RTABMapping using ZED 2i",
      footerLink: [
        {
          // name: "Youtube",
          // url: "https://www.youtube.com/watch?v=4AaZlb4nLxw"
        }
      ]
    }
    // {
    //   image: require("./assets/images/entryexit.png"),
    //   projectName: "Ad Blocker Extension",
    //   projectDesc: "The project automates entry logging of students and staffs with a web interface, MySQL database and query system. Designed for educational institutions or businesses, it improves security and simplifies attendance tracking.",
    //   footerLink: [
    //     {
    //       // name: "Youtube",
    //       // url: "https://www.youtube.com/watch?v=4AaZlb4nLxw"
    //     }
    //   ]
    // },
   
  ],
  
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "ERC Remote Finalist",
      subtitle:
        "Ranked 2nd worldwide in Qualification A round ",
      image: require("./assets/images/ercLogo.png"),
      imageAlt: "European Rover Challenge",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1OP22OdUgyMPw4LVv8jHAeFRlSj0Z5ERl/view"
        }
      //   {
      //     name: "Award Letter",
      //     url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
      //   },
        //  {
        //   name: "Appreciation Letter",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
         ]
    }
    // {
    //   title: "Google Assistant Action",
    //   subtitle:
    //     "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
    //   image: require("./assets/images/googleAssistantLogo.webp"),
    //   imageAlt: "Google Assistant Action Logo",
    //   footerLink: [
    //     {
    //       name: "View Google Assistant Action",
    //       url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
    //     }
    //   ]
    // },

    // {
    //   title: "PWA Web App Developer",
    //   subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
    //   image: require("./assets/images/pwaLogo.webp"),
    //   imageAlt: "PWA Logo",
    //   footerLink: [
    //     {name: "Certification", url: ""},
    //     {
    //       name: "Final Project",
    //       url: "https://pakistan-olx-1.firebaseapp.com/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Blogs on the way",
      description:
        "Be patient"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91 8094114546",
  email_address: "vishalmimani008@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
